var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _radialGradient, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _linearGradient39, _linearGradient40, _linearGradient41, _linearGradient42, _linearGradient43, _linearGradient44, _linearGradient45, _linearGradient46, _linearGradient47, _linearGradient48, _linearGradient49, _linearGradient50, _linearGradient51, _linearGradient52, _linearGradient53, _linearGradient54, _linearGradient55, _linearGradient56, _linearGradient57, _linearGradient58, _linearGradient59, _linearGradient60, _linearGradient61, _linearGradient62, _linearGradient63, _linearGradient64, _linearGradient65, _linearGradient66, _linearGradient67, _linearGradient68, _linearGradient69, _linearGradient70, _linearGradient71, _linearGradient72, _clipPath, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCashier3D(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 30,
    viewBox: "0 0 30 30",
    width: 30,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#ffcd3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#ffad2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa325"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 25.0697,
    x2: 25.0697,
    xlinkHref: "#a",
    y1: 24.4432,
    y2: 26.5498
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7044"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 25.0697,
    x2: 25.0697,
    xlinkHref: "#c",
    y1: 24.4737,
    y2: 28.0166
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbed21"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 25.061,
    x2: 24.2211,
    xlinkHref: "#e",
    y1: 25.0413,
    y2: 23.01
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 25.0697,
    x2: 25.0697,
    xlinkHref: "#a",
    y1: 22.8186,
    y2: 24.9253
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: 25.0697,
    x2: 25.0697,
    xlinkHref: "#c",
    y1: 22.8492,
    y2: 26.3921
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: 25.061,
    x2: 24.2211,
    xlinkHref: "#e",
    y1: 23.4163,
    y2: 21.385
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    x1: 25.0697,
    x2: 25.0697,
    xlinkHref: "#a",
    y1: 21.1936,
    y2: 23.3003
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientUnits: "userSpaceOnUse",
    x1: 25.0697,
    x2: 25.0697,
    xlinkHref: "#c",
    y1: 21.2242,
    y2: 24.7671
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    gradientUnits: "userSpaceOnUse",
    x1: 25.061,
    x2: 24.2211,
    xlinkHref: "#e",
    y1: 21.7918,
    y2: 19.7605
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    gradientUnits: "userSpaceOnUse",
    x1: 25.0697,
    x2: 25.0697,
    xlinkHref: "#a",
    y1: 19.5686,
    y2: 21.6753
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    gradientUnits: "userSpaceOnUse",
    x1: 25.0697,
    x2: 25.0697,
    xlinkHref: "#c",
    y1: 19.5992,
    y2: 23.1422
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    gradientUnits: "userSpaceOnUse",
    x1: 25.061,
    x2: 24.2211,
    xlinkHref: "#e",
    y1: 20.1668,
    y2: 18.1355
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    gradientUnits: "userSpaceOnUse",
    x1: 25.0697,
    x2: 25.0697,
    xlinkHref: "#a",
    y1: 17.9441,
    y2: 20.0508
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    gradientUnits: "userSpaceOnUse",
    x1: 25.0697,
    x2: 25.0697,
    xlinkHref: "#c",
    y1: 17.9746,
    y2: 21.5176
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    gradientUnits: "userSpaceOnUse",
    x1: 25.061,
    x2: 24.2211,
    xlinkHref: "#e",
    y1: 18.5424,
    y2: 16.511
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    gradientUnits: "userSpaceOnUse",
    x1: 25.0697,
    x2: 25.0697,
    xlinkHref: "#a",
    y1: 16.3191,
    y2: 18.4258
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    gradientUnits: "userSpaceOnUse",
    x1: 25.0697,
    x2: 25.0697,
    xlinkHref: "#c",
    y1: 16.3497,
    y2: 19.8926
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    gradientUnits: "userSpaceOnUse",
    x1: 25.061,
    x2: 24.2211,
    xlinkHref: "#e",
    y1: 16.9173,
    y2: 14.886
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "v"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3f3ced",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2796,
    stopColor: "#3c3de4",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    stopColor: "#3541cc",
    stopOpacity: 0.731
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2f43bb"
  }))), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    gradientUnits: "userSpaceOnUse",
    x1: 24.7576,
    x2: 24.7576,
    xlinkHref: "#v",
    y1: 22.9047,
    y2: 27.5222
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    gradientUnits: "userSpaceOnUse",
    x1: 24.7576,
    x2: 24.7576,
    xlinkHref: "#v",
    y1: 20.7871,
    y2: 25.4046
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "y"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4ab272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3386,
    stopColor: "#47b071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5502,
    stopColor: "#3fa870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#309b6d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8837,
    stopColor: "#1c8869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#077565"
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "z",
    cx: 11.6808,
    cy: 12.1784,
    gradientUnits: "userSpaceOnUse",
    r: 19.8575,
    xlinkHref: "#y"
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "A"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#005a01",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005a01"
  }))), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    gradientUnits: "userSpaceOnUse",
    x1: 7.91953,
    x2: 7.28341,
    xlinkHref: "#A",
    y1: 21.3657,
    y2: 41.1924
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    gradientUnits: "userSpaceOnUse",
    x1: 13.71,
    x2: 16.5376,
    xlinkHref: "#A",
    y1: 25.2719,
    y2: 36.0635
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    gradientUnits: "userSpaceOnUse",
    x1: 22.4587,
    x2: 21.422,
    xlinkHref: "#A",
    y1: 25.0598,
    y2: 38.349
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "E"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#91f27f",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffed82"
  }))), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    gradientUnits: "userSpaceOnUse",
    x1: 13.8356,
    x2: 0.546444,
    xlinkHref: "#E",
    y1: 17.2998,
    y2: -6.45092
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    gradientUnits: "userSpaceOnUse",
    x1: 23.1055,
    x2: 6.26566,
    xlinkHref: "#A",
    y1: 21.899,
    y2: 12.3706
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "H"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1876,
    stopColor: "#fdbf3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4837,
    stopColor: "#f7a848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8493,
    stopColor: "#ed835b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e97264"
  }))), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    gradientUnits: "userSpaceOnUse",
    x1: 13.2852,
    x2: 22.5094,
    xlinkHref: "#H",
    y1: 14.4439,
    y2: 22.3957
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    gradientUnits: "userSpaceOnUse",
    x1: 14.1508,
    x2: 17.2611,
    xlinkHref: "#y",
    y1: -0.892721,
    y2: 5.68116
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "K",
    gradientUnits: "userSpaceOnUse",
    x1: 15.1723,
    x2: 19.3663,
    xlinkHref: "#A",
    y1: 2.5774,
    y2: 9.08057
  })), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    gradientUnits: "userSpaceOnUse",
    x1: 15.3778,
    x2: 15.5899,
    xlinkHref: "#A",
    y1: 0.219324,
    y2: 2.30456
  })), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    gradientUnits: "userSpaceOnUse",
    x1: 14.4577,
    x2: 6.43471,
    xlinkHref: "#E",
    y1: 2.78546,
    y2: 2.6441
  })), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "N",
    gradientUnits: "userSpaceOnUse",
    x1: 15.2152,
    x2: 15.2152,
    xlinkHref: "#H",
    y1: 5.15687,
    y2: 6.15651
  })), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "O",
    gradientUnits: "userSpaceOnUse",
    x1: 14.4394,
    x2: 8.219,
    xlinkHref: "#A",
    y1: 23.7097,
    y2: 23.1913
  })), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    gradientUnits: "userSpaceOnUse",
    x1: 5.24225,
    x2: 5.24225,
    xlinkHref: "#a",
    y1: 27.926,
    y2: 30.6716
  })), _linearGradient42 || (_linearGradient42 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q",
    gradientUnits: "userSpaceOnUse",
    x1: 5.24237,
    x2: 5.24237,
    xlinkHref: "#c",
    y1: 27.9658,
    y2: 32.5833
  })), _linearGradient43 || (_linearGradient43 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "R",
    gradientUnits: "userSpaceOnUse",
    x1: 5.24226,
    x2: 5.24226,
    xlinkHref: "#c",
    y1: 27.9658,
    y2: 32.5833
  })), _linearGradient44 || (_linearGradient44 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "S",
    gradientUnits: "userSpaceOnUse",
    x1: 5.231,
    x2: 4.13624,
    xlinkHref: "#e",
    y1: 28.7057,
    y2: 26.0582
  })), _linearGradient45 || (_linearGradient45 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "T",
    gradientUnits: "userSpaceOnUse",
    x1: 5.24225,
    x2: 5.24225,
    xlinkHref: "#a",
    y1: 25.8083,
    y2: 28.5539
  })), _linearGradient46 || (_linearGradient46 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "U",
    gradientUnits: "userSpaceOnUse",
    x1: 5.24237,
    x2: 5.24237,
    xlinkHref: "#c",
    y1: 25.8482,
    y2: 30.4656
  })), _linearGradient47 || (_linearGradient47 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "V",
    gradientUnits: "userSpaceOnUse",
    x1: 5.24226,
    x2: 5.24226,
    xlinkHref: "#c",
    y1: 25.8481,
    y2: 30.4656
  })), _linearGradient48 || (_linearGradient48 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "W",
    gradientUnits: "userSpaceOnUse",
    x1: 5.231,
    x2: 4.13624,
    xlinkHref: "#e",
    y1: 26.588,
    y2: 23.9406
  })), _linearGradient49 || (_linearGradient49 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "X",
    gradientUnits: "userSpaceOnUse",
    x1: 5.24225,
    x2: 5.24225,
    xlinkHref: "#a",
    y1: 23.6906,
    y2: 26.4362
  })), _linearGradient50 || (_linearGradient50 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Y",
    gradientUnits: "userSpaceOnUse",
    x1: 5.24237,
    x2: 5.24237,
    xlinkHref: "#c",
    y1: 23.7304,
    y2: 28.3479
  })), _linearGradient51 || (_linearGradient51 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Z",
    gradientUnits: "userSpaceOnUse",
    x1: 5.24226,
    x2: 5.24226,
    xlinkHref: "#c",
    y1: 23.7304,
    y2: 28.3479
  })), _linearGradient52 || (_linearGradient52 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    gradientUnits: "userSpaceOnUse",
    x1: 5.231,
    x2: 4.13624,
    xlinkHref: "#e",
    y1: 24.4703,
    y2: 21.8229
  })), _linearGradient53 || (_linearGradient53 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab",
    gradientUnits: "userSpaceOnUse",
    x1: 5.24225,
    x2: 5.24225,
    xlinkHref: "#a",
    y1: 21.5729,
    y2: 24.3186
  })), _linearGradient54 || (_linearGradient54 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac",
    gradientUnits: "userSpaceOnUse",
    x1: 5.24237,
    x2: 5.24237,
    xlinkHref: "#c",
    y1: 21.6128,
    y2: 26.2304
  })), _linearGradient55 || (_linearGradient55 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad",
    gradientUnits: "userSpaceOnUse",
    x1: 5.24226,
    x2: 5.24226,
    xlinkHref: "#c",
    y1: 21.6128,
    y2: 26.2303
  })), _linearGradient56 || (_linearGradient56 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae",
    gradientUnits: "userSpaceOnUse",
    x1: 5.231,
    x2: 4.13624,
    xlinkHref: "#e",
    y1: 22.3526,
    y2: 19.7052
  })), _linearGradient57 || (_linearGradient57 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "af",
    gradientUnits: "userSpaceOnUse",
    x1: 5.24225,
    x2: 5.24225,
    xlinkHref: "#a",
    y1: 19.4553,
    y2: 22.2009
  })), _linearGradient58 || (_linearGradient58 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ag",
    gradientUnits: "userSpaceOnUse",
    x1: 5.24237,
    x2: 5.24237,
    xlinkHref: "#c",
    y1: 19.495,
    y2: 24.1126
  })), _linearGradient59 || (_linearGradient59 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ah",
    gradientUnits: "userSpaceOnUse",
    x1: 5.24226,
    x2: 5.24226,
    xlinkHref: "#c",
    y1: 19.495,
    y2: 24.1126
  })), _linearGradient60 || (_linearGradient60 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai",
    gradientUnits: "userSpaceOnUse",
    x1: 5.231,
    x2: 4.13624,
    xlinkHref: "#e",
    y1: 20.235,
    y2: 17.5876
  })), _linearGradient61 || (_linearGradient61 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aj",
    gradientUnits: "userSpaceOnUse",
    x1: 5.24225,
    x2: 5.24225,
    xlinkHref: "#a",
    y1: 17.3376,
    y2: 20.0832
  })), _linearGradient62 || (_linearGradient62 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ak",
    gradientUnits: "userSpaceOnUse",
    x1: 5.24237,
    x2: 5.24237,
    xlinkHref: "#c",
    y1: 17.3774,
    y2: 21.9949
  })), _linearGradient63 || (_linearGradient63 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "al",
    gradientUnits: "userSpaceOnUse",
    x1: 5.24226,
    x2: 5.24226,
    xlinkHref: "#c",
    y1: 17.3774,
    y2: 21.9949
  })), _linearGradient64 || (_linearGradient64 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "am",
    gradientUnits: "userSpaceOnUse",
    x1: 5.231,
    x2: 4.13624,
    xlinkHref: "#e",
    y1: 18.1173,
    y2: 15.4698
  })), _linearGradient65 || (_linearGradient65 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "an",
    gradientUnits: "userSpaceOnUse",
    x1: 22.5567,
    x2: 22.5567,
    xlinkHref: "#a",
    y1: 27.926,
    y2: 30.6716
  })), _linearGradient66 || (_linearGradient66 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ao",
    gradientUnits: "userSpaceOnUse",
    x1: 22.5568,
    x2: 22.5568,
    xlinkHref: "#c",
    y1: 27.9658,
    y2: 32.5833
  })), _linearGradient67 || (_linearGradient67 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ap",
    gradientUnits: "userSpaceOnUse",
    x1: 22.5567,
    x2: 22.5567,
    xlinkHref: "#c",
    y1: 27.9658,
    y2: 32.5833
  })), _linearGradient68 || (_linearGradient68 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "aq",
    gradientUnits: "userSpaceOnUse",
    x1: 22.5452,
    x2: 21.4504,
    xlinkHref: "#e",
    y1: 28.7057,
    y2: 26.0582
  })), _linearGradient69 || (_linearGradient69 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ar",
    gradientUnits: "userSpaceOnUse",
    x1: 22.5567,
    x2: 22.5567,
    xlinkHref: "#a",
    y1: 25.8083,
    y2: 28.5539
  })), _linearGradient70 || (_linearGradient70 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "as",
    gradientUnits: "userSpaceOnUse",
    x1: 22.5568,
    x2: 22.5568,
    xlinkHref: "#c",
    y1: 25.8482,
    y2: 30.4656
  })), _linearGradient71 || (_linearGradient71 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "at",
    gradientUnits: "userSpaceOnUse",
    x1: 22.5567,
    x2: 22.5567,
    xlinkHref: "#c",
    y1: 25.8481,
    y2: 30.4656
  })), _linearGradient72 || (_linearGradient72 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "au",
    gradientUnits: "userSpaceOnUse",
    x1: 22.5452,
    x2: 21.4504,
    xlinkHref: "#e",
    y1: 26.588,
    y2: 23.9406
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "av"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h30v30h-30z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#av)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "m28.6123 26.0345h-7.0851c-.1354 0-.2452-.1098-.2452-.2452v-1.1344c0-.1355.1097-.2452.2452-.2452h7.0851c.1354 0 .2452.1097.2452.2452v1.1344c0 .1354-.1098.2452-.2452.2452z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.7129 26.0345h-5.2863c-.1177 0-.213-.0953-.213-.2129v-1.199c0-.1176.0953-.2129.213-.2129h5.2863c.1175 0 .2129.0953.2129.2129v1.199c0 .1176-.0953.2129-.2129.2129z",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.7411 24.6074c-.1355 0-.2453.1098-.2453.2452v1.1344c0 .0158.0017.0311.0045.046.0089.001.0178.0016.027.0016h7.085c.1355 0 .2453-.1098.2453-.2452v-1.1345c0-.0157-.0017-.031-.0045-.0459-.0089-.001-.0178-.0016-.027-.0016z",
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.6123 24.41h-7.0851c-.1354 0-.2452-.1098-.2452-.2452v-1.1344c0-.1355.1097-.2452.2452-.2452h7.0851c.1354 0 .2452.1097.2452.2452v1.1344c0 .1354-.1098.2452-.2452.2452z",
    fill: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.7129 24.41h-5.2863c-.1177 0-.213-.0953-.213-.2129v-1.199c0-.1176.0953-.2129.213-.2129h5.2863c.1175 0 .2129.0953.2129.2129v1.199c0 .1176-.0953.2129-.2129.2129z",
    fill: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.7411 22.9824c-.1355 0-.2453.1098-.2453.2452v1.1344c0 .0158.0017.0311.0045.046.0089.001.0178.0016.027.0016h7.085c.1355 0 .2453-.1098.2453-.2452v-1.1345c0-.0157-.0017-.031-.0045-.0459-.0089-.001-.0178-.0016-.027-.0016z",
    fill: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.6123 22.785h-7.0851c-.1354 0-.2452-.1098-.2452-.2452v-1.1344c0-.1354.1097-.2452.2452-.2452h7.0851c.1354 0 .2452.1097.2452.2452v1.1344c0 .1354-.1098.2452-.2452.2452z",
    fill: "url(#j)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.7129 22.785h-5.2863c-.1177 0-.213-.0953-.213-.213v-1.1989c0-.1176.0953-.2129.213-.2129h5.2863c.1175 0 .2129.0953.2129.2129v1.1989c0 .1177-.0953.213-.2129.213z",
    fill: "url(#k)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.7411 21.3579c-.1355 0-.2453.1098-.2453.2452v1.1344c0 .0158.0017.0311.0045.046.0089.001.0178.0016.027.0016h7.085c.1355 0 .2453-.1098.2453-.2453v-1.1344c0-.0157-.0017-.031-.0045-.046-.0089-.0009-.0178-.0015-.027-.0015z",
    fill: "url(#l)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.6123 21.16h-7.0851c-.1354 0-.2452-.1098-.2452-.2452v-1.1344c0-.1355.1097-.2452.2452-.2452h7.0851c.1354 0 .2452.1097.2452.2452v1.1344c0 .1354-.1098.2452-.2452.2452z",
    fill: "url(#m)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.7129 21.16h-5.2863c-.1177 0-.213-.0953-.213-.2129v-1.199c0-.1176.0953-.2129.213-.2129h5.2863c.1175 0 .2129.0953.2129.2129v1.199c0 .1176-.0953.2129-.2129.2129z",
    fill: "url(#n)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.7411 19.7329c-.1355 0-.2453.1098-.2453.2452v1.1344c0 .0158.0017.0311.0045.046.0089.001.0178.0016.027.0016h7.085c.1355 0 .2453-.1098.2453-.2453v-1.1344c0-.0157-.0017-.031-.0045-.046-.0089-.0009-.0178-.0015-.027-.0015z",
    fill: "url(#o)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.6123 19.5355h-7.0851c-.1354 0-.2452-.1098-.2452-.2452v-1.1344c0-.1354.1097-.2453.2452-.2453h7.0851c.1354 0 .2452.1098.2452.2453v1.1344c0 .1354-.1098.2452-.2452.2452z",
    fill: "url(#p)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.7129 19.5355h-5.2863c-.1177 0-.213-.0953-.213-.213v-1.1989c0-.1176.0953-.213.213-.213h5.2863c.1175 0 .2129.0954.2129.213v1.1989c0 .1176-.0953.213-.2129.213z",
    fill: "url(#q)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.7411 18.1084c-.1355 0-.2453.1098-.2453.2452v1.1344c0 .0158.0017.0311.0045.046.0089.001.0178.0015.027.0015h7.085c.1355 0 .2453-.1097.2453-.2452v-1.1344c0-.0157-.0017-.031-.0045-.046-.0089-.0009-.0178-.0015-.027-.0015z",
    fill: "url(#r)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.6123 17.9105h-7.0851c-.1354 0-.2452-.1098-.2452-.2452v-1.1344c0-.1355.1097-.2453.2452-.2453h7.0851c.1354 0 .2452.1098.2452.2453v1.1344c0 .1354-.1098.2452-.2452.2452z",
    fill: "url(#s)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.7129 17.9105h-5.2863c-.1177 0-.213-.0953-.213-.2129v-1.199c0-.1176.0953-.213.213-.213h5.2863c.1175 0 .2129.0954.2129.213v1.199c0 .1176-.0953.2129-.2129.2129z",
    fill: "url(#t)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.7411 16.4834c-.1355 0-.2453.1098-.2453.2452v1.1344c0 .0158.0017.0311.0045.046.0089.001.0178.0015.027.0015h7.085c.1355 0 .2453-.1097.2453-.2452v-1.1344c0-.0157-.0017-.031-.0045-.046-.0089-.0009-.0178-.0015-.027-.0015z",
    fill: "url(#u)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.7411 24.6074c-.1355 0-.2453.1098-.2453.2452v1.1344c0 .0158.0017.0311.0045.046.0089.001.0178.0016.027.0016h7.085c.1355 0 .2453-.1098.2453-.2452v-1.1345c0-.0157-.0017-.031-.0045-.0459-.0089-.001-.0178-.0016-.027-.0016z",
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.7411 22.9824c-.1355 0-.2453.1098-.2453.2452v1.1344c0 .0158.0017.0311.0045.046.0089.001.0178.0016.027.0016h7.085c.1355 0 .2453-.1098.2453-.2452v-1.1345c0-.0157-.0017-.031-.0045-.0459-.0089-.001-.0178-.0016-.027-.0016z",
    fill: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.7411 21.3579c-.1355 0-.2453.1098-.2453.2452v1.1344c0 .0158.0017.0311.0045.046.0089.001.0178.0016.027.0016h7.085c.1355 0 .2453-.1098.2453-.2453v-1.1344c0-.0157-.0017-.031-.0045-.046-.0089-.0009-.0178-.0015-.027-.0015z",
    fill: "url(#l)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.7411 19.7329c-.1355 0-.2453.1098-.2453.2452v1.1344c0 .0158.0017.0311.0045.046.0089.001.0178.0016.027.0016h7.085c.1355 0 .2453-.1098.2453-.2453v-1.1344c0-.0157-.0017-.031-.0045-.046-.0089-.0009-.0178-.0015-.027-.0015z",
    fill: "url(#o)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.7411 18.1084c-.1355 0-.2453.1098-.2453.2452v1.1344c0 .0158.0017.0311.0045.046.0089.001.0178.0015.027.0015h7.085c.1355 0 .2453-.1097.2453-.2452v-1.1344c0-.0157-.0017-.031-.0045-.046-.0089-.0009-.0178-.0015-.027-.0015z",
    fill: "url(#r)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.7411 16.4834c-.1355 0-.2453.1098-.2453.2452v1.1344c0 .0158.0017.0311.0045.046.0089.001.0178.0015.027.0015h7.085c.1355 0 .2453-.1097.2453-.2452v-1.1344c0-.0157-.0017-.031-.0045-.046-.0089-.0009-.0178-.0015-.027-.0015z",
    fill: "url(#u)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m25.9439 24.9389h-2.3725c-.0924 0-.1673-.0749-.1673-.1673v-1.783c0-.0924.0749-.1673.1673-.1673h2.3725c.0924 0 .1673.0749.1673.1673v1.783c0 .0924-.0749.1673-.1673.1673z",
    fill: "url(#w)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.9439 22.8213h-2.3725c-.0924 0-.1673-.075-.1673-.1674v-1.7829c0-.0924.0749-.1674.1673-.1674h2.3725c.0924 0 .1673.075.1673.1674v1.7829c0 .0924-.0749.1674-.1673.1674z",
    fill: "url(#x)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.5703 15.7456-.8486-4.4502c-.633-3.3194-3.5354-5.72069-6.9146-5.72069h-3.1838c-3.3792 0-6.28163 2.40129-6.91457 5.72069l-.48112 2.5231c-.46235 2.4247-1.20141 4.7969-2.3067 7.004-.32318.6453-.49289 1.3807-.46106 2.1587.09194 2.2509 2.07294 4.1877 4.32529 4.2317.01653.0003.033.0006.04947.0007 1.02188.0089 2.00577.4071 2.72239 1.1356.801.8143 1.9151 1.3193 3.1476 1.3193 1.4958 0 2.8176-.7437 3.6167-1.8813.2572-.3662.6791-.5743 1.1267-.5734h.0077c.1923 0 .3813-.0143.5659-.0417.3482-.0516.7005.0373.988.2406.7775.55 1.7402.8552 2.7765.8028 2.2179-.1123 4.0271-1.8877 4.1778-4.1033.0542-.7971-.1035-1.5527-.4222-2.2164-.9354-1.9479-1.5667-4.0276-1.9714-6.1502z",
    fill: "url(#z)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.87364 27.2136c2.43976 0 4.41756-1.9778 4.41756-4.4176s-1.9778-4.4176-4.41756-4.4176-4.41759 1.9778-4.41759 4.4176 1.97783 4.4176 4.41759 4.4176z",
    fill: "url(#B)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.7045 29.6682c2.4397 0 4.4175-1.9778 4.4175-4.4176s-1.9778-4.4176-4.4175-4.4176c-2.4398 0-4.41763 1.9778-4.41763 4.4176s1.97783 4.4176 4.41763 4.4176z",
    fill: "url(#C)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.5567 28.2209c2.4398 0 4.4176-1.9778 4.4176-4.4176 0-2.4397-1.9778-4.4176-4.4176-4.4176-2.4397 0-4.4175 1.9779-4.4175 4.4176 0 2.4398 1.9778 4.4176 4.4175 4.4176z",
    fill: "url(#D)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.9637 24.1121c.0543-.7972-.1034-1.5528-.4221-2.2164-.9354-1.9479-1.5667-4.0277-1.9714-6.1503l-.8486-4.4502c-.2297-1.2045-.7593-2.287-1.5009-3.17888-1.2274-1.0163-2.7986-1.6173-4.4892-1.6173h-3.1838c-3.3792 0-6.28167 2.4013-6.91461 5.72068l-.48112 2.5231c-.46235 2.4248-1.20141 4.7969-2.3067 7.0039-.32318.6453-.49288 1.3807-.46112 2.1587.03618.8856.36565 1.7219.88812 2.4141.719.5415 1.59312.8752 2.51271.8932.01652.0003.033.0005.04947.0007 1.02188.0088 2.00582.407 2.72245 1.1356.801.8142 1.9151 1.3192 3.1476 1.3192 1.4958 0 2.8176-.7436 3.6167-1.8812.2572-.3663.6791-.5744 1.1267-.5735h.0077c.1923 0 .3813-.0142.5659-.0417.3482-.0515.7005.0373.988.2406.7775.55 1.7402.8553 2.7765.8028 2.2179-.1121 4.0271-1.8875 4.1777-4.1031z",
    fill: "url(#F)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.7816 10.7746c-.3198-.0989-.6237-.1702-.9115-.2141-.1389-.0212-.2791-.0384-.4204-.0519-.0012-.0007-.0023-.0013-.0035-.002l-.6475-.67068c-.1279-.08347-.2666-.12547-.4158-.12547-.1707 0-.3146.03976-.4318.11871-.1174.07917-.1759.17314-.1759.28154v.4153c-.9274.1304-1.6924.473-2.2946 1.0274-.6025.5544-.9035 1.3152-.9035 2.2827 0 .3945.0693.7543.2079 1.0794.1384.3253.2984.5917.4798.7995l2.5105 2.5129v1.4928c-.4158-.0744-.869-.2851-1.3592-.6316-.4905-.3463-.837-.5197-1.0394-.5197-.2879 0-.5412.1494-.7596.4478-.2186.2985-.3278.5971-.3278.8955 0 .3888.1908.748.5717 1.0777l6.2603 6.2603c.1059-.0247.2154-.0375.3266-.0372h.0078c.1923 0 .3812-.0143.5658-.0417.3483-.0516.7006.0373.988.2406.7775.5499 1.7402.8552 2.7766.8028 2.2179-.1123 4.027-1.8877 4.1777-4.1033.0543-.7972-.1034-1.5527-.4221-2.2164-.651-1.3556-1.1544-2.7753-1.537-4.2287l-6.4476-6.4474c-.1974-.1977-.4557-.3458-.7755-.4448z",
    fill: "url(#G)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.941 17.3062c-.1336-.341-.2934-.6237-.4798-.8475-.1867-.2239-.4345-.437-.7437-.6397-.3093-.2024-.5863-.357-.8315-.4637-.2453-.1064-.5436-.2291-.8954-.3678v-2.3347c.3837.032.7541.1386 1.1114.3198.357.1814.6101.2719.7595.2719.3091 0 .5517-.1517.7276-.455s.2639-.5962.2639-.878c0-.2636-.0987-.4942-.2959-.6921-.1974-.1977-.4557-.3458-.7755-.4448-.3198-.0989-.6237-.1702-.9115-.2141-.2879-.044-.5812-.0715-.8795-.0825v-.369c0-.0985-.064-.18943-.1919-.27314-.1279-.08347-.2666-.12541-.4158-.12541-.1707 0-.3146.03976-.4318.11871-.1174.07917-.1759.17314-.1759.28154v.4153c-.9274.1304-1.6924.473-2.2946 1.0274-.6025.5544-.9035 1.3152-.9035 2.2827 0 .3945.0692.7543.2079 1.0794.1384.3253.2984.5917.4798.7995.1811.2079.437.4106.7675.6077.3303.1974.6077.3438.8315.4397.2239.0959.5277.2186.9115.3678v2.5905c-.4158-.0744-.869-.2851-1.3592-.6316-.4905-.3463-.837-.5197-1.0394-.5197-.2879 0-.5412.1494-.7596.4478-.2186.2985-.3278.5971-.3278.8955 0 .5225.3438.9914 1.0314 1.4072.6877.4158 1.5057.6397 2.4546.6716v.3998c0 .1172.0585.2183.1759.3038.1172.0852.261.1279.4318.1279.1491 0 .2878-.0454.4157-.1359.128-.0907.192-.1894.192-.2958v-.4638c.9594-.1599 1.7242-.5382 2.2946-1.1353.5702-.597.8555-1.3805.8555-2.3508 0-.4157-.0667-.7939-.1998-1.1352zm-4.0058-2.7025c-.6824-.2878-1.0235-.6237-1.0235-1.0074 0-.4583.3411-.7569 1.0235-.8956zm.8955 5.1011v-2.1428c.6501.3093.9754.6876.9754 1.1354 0 .5224-.3253.8582-.9754 1.0074z",
    fill: "url(#I)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.3849 5.57451h-4.3395l-1.9742-3.7847c-.2915-.55871.0413-1.240001.6611-1.353648l1.2929-.237059c1.4479-.2654707 2.932-.2654707 4.3799 0l1.2929.237059c.6198.113647.9526.794878.6611 1.353648z",
    fill: "url(#J)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.9366 5.57451h-1.4432l-.6566-3.7847c-.0969-.55871.0138-1.240001.2199-1.353648l.43-.237059c.4815-.2654707.9751-.2654707 1.4567 0l.43.237059c.2062.113647.3168.794878.2199 1.353648z",
    fill: "url(#K)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.2938.816853c.0846.120353.042.288057-.0892.354587-.6157.31312-1.3438.31312-1.9595 0l-.5442-.276352c-.6157-.313117-1.3438-.313117-1.9595 0l-.5435.276352c-.6158.31312-1.3438.31312-1.9595 0l-.5694-.289587c-.1994-.10147-.1623-.403176.0577-.444471.0019-.000353.0037-.000705.0056-.001058l1.2928-.23753c1.4477-.2650587 2.9321-.2650587 4.3798 0l1.2929.23753c.2553.046529.4616.189353.596.380529z",
    fill: "url(#L)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.3715 1.34751c.0291-.07052.0502-.14288.0656-.21582-.085-.339646-.3573-.625469-.7392-.695528l-1.2929-.237059c-1.4479-.2654707-2.9321-.2654707-4.3799 0l-.9643.176823c-.1209.289471-.1363.648534-.0031.971584l1.7422 4.227h3.5849l1.1654-2.23417z",
    fill: "url(#M)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.2152 5.99898c-.9406 0-1.831-.06076-2.5606-.17305-.2403-.037-.4015-.26606-.353-.5043.045-.22153.2555-.369.479-.33476.6853.10506 1.5473.16388 2.4346.16388s1.7493-.05882 2.4347-.16388c.2235-.03424.4339.11317.479.33476.0485.23824-.1127.46735-.353.5043-.7297.11229-1.62.17305-2.5607.17305z",
    fill: "url(#N)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.1687 17.5391c-.0337-.1404-.1588-.2452-.30946-.2452h-1.17218-2.25859-1.07929c-.3873 1.2096-.85894 2.3909-1.42847 3.5281-.32318.6453-.49288 1.3807-.46112 2.1587.09194 2.2509 2.073 4.1877 4.32535 4.2318.01653.0003.033.0005.04947.0007 1.02189.0088 2.00583.407 2.72249 1.1356.8009.8142 1.915 1.3192 3.1476 1.3192 1.4958 0 2.8176-.7436 3.6166-1.8812.2573-.3663.6791-.5744 1.1267-.5735h.0078c.1923 0 .3812-.0142.5659-.0416.3482-.0516.7005.0372.988.2405.033.0234.0667.0457.1004.0681z",
    fill: "url(#O)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.85925 30h-9.233998c-.17647 0-.319588-.1431-.319588-.3196v-1.4785c0-.1765.143059-.3196.319588-.3196h9.233998c.17645 0 .31955.1431.31955.3196v1.4785c0 .1765-.1431.3196-.31955.3196z",
    fill: "url(#P)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.6872 30h-6.88965c-.1533 0-.27753-.1243-.27753-.2776v-1.5625c0-.1533.12423-.2776.27753-.2776h6.88965c.15323 0 .27753.1243.27753.2776v1.5625c0 .1533-.12424.2776-.27753.2776z",
    fill: "url(#Q)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.4285 30h-2.37248c-.09241 0-.16735-.075-.16735-.1674v-1.7829c0-.0924.07494-.1674.16735-.1674h2.37248c.09241 0 .16735.075.16735.1674v1.7829c0 .0924-.07494.1674-.16735.1674z",
    fill: "url(#R)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.904061 28.1401c-.17653 0-.319588.1431-.319588.3196v1.4785c0 .0205.002117.0405.005823.0599.01153.0013.023235.002.035118.002h9.233996c.17649 0 .31959-.143.31959-.3196v-1.4784c0-.0206-.0021-.0406-.0058-.06-.0116-.0012-.0233-.002-.0351-.002z",
    fill: "url(#S)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.85925 27.8823h-9.233998c-.17647 0-.319588-.1431-.319588-.3196v-1.4785c0-.1765.143059-.3196.319588-.3196h9.233998c.17645 0 .31955.1431.31955.3196v1.4785c0 .1765-.1431.3196-.31955.3196z",
    fill: "url(#T)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.6872 27.8824h-6.88965c-.1533 0-.27753-.1243-.27753-.2776v-1.5626c0-.1533.12423-.2776.27753-.2776h6.88965c.15323 0 .27753.1243.27753.2776v1.5626c0 .1533-.12424.2776-.27753.2776z",
    fill: "url(#U)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.4285 27.8823h-2.37248c-.09241 0-.16735-.0749-.16735-.1674v-1.7829c0-.0924.07494-.1674.16735-.1674h2.37248c.09241 0 .16735.075.16735.1674v1.7829c0 .0925-.07494.1674-.16735.1674z",
    fill: "url(#V)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.904061 26.0225c-.17653 0-.319588.143-.319588.3195v1.4785c0 .0205.002117.0405.005823.06.01153.0013.023235.002.035118.002h9.233996c.17649 0 .31959-.1431.31959-.3196v-1.4785c0-.0205-.0021-.0405-.0058-.0599-.0116-.0013-.0233-.002-.0351-.002z",
    fill: "url(#W)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.85925 25.7646h-9.233998c-.17647 0-.319588-.143-.319588-.3196v-1.4784c0-.1765.143059-.3196.319588-.3196h9.233998c.17645 0 .31955.143.31955.3196v1.4784c0 .1766-.1431.3196-.31955.3196z",
    fill: "url(#X)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.6872 25.7646h-6.88965c-.1533 0-.27753-.1242-.27753-.2775v-1.5626c0-.1533.12423-.2775.27753-.2775h6.88965c.15323 0 .27753.1242.27753.2775v1.5626c0 .1533-.12424.2775-.27753.2775z",
    fill: "url(#Y)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.4285 25.7646h-2.37248c-.09241 0-.16735-.0749-.16735-.1673v-1.783c0-.0924.07494-.1673.16735-.1673h2.37248c.09241 0 .16735.0749.16735.1673v1.783c0 .0924-.07494.1673-.16735.1673z",
    fill: "url(#Z)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.904061 23.9048c-.17653 0-.319588.143-.319588.3196v1.4784c0 .0206.002117.0406.005823.06.01153.0012.023235.002.035118.002h9.233996c.17649 0 .31959-.1431.31959-.3196v-1.4785c0-.0205-.0021-.0404-.0058-.0599-.0116-.0013-.0233-.002-.0351-.002z",
    fill: "url(#aa)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.85925 23.6469h-9.233998c-.17647 0-.319588-.143-.319588-.3195v-1.4785c0-.1765.143059-.3196.319588-.3196h9.233998c.17645 0 .31955.1431.31955.3196v1.4785c0 .1765-.1431.3195-.31955.3195z",
    fill: "url(#ab)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.6872 23.647h-6.88965c-.1533 0-.27753-.1242-.27753-.2775v-1.5627c0-.1532.12423-.2775.27753-.2775h6.88965c.15323 0 .27753.1242.27753.2775v1.5627c0 .1533-.12424.2775-.27753.2775z",
    fill: "url(#ac)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.4285 23.6469h-2.37248c-.09241 0-.16735-.0749-.16735-.1673v-1.783c0-.0924.07494-.1673.16735-.1673h2.37248c.09241 0 .16735.0749.16735.1673v1.783c0 .0925-.07494.1673-.16735.1673z",
    fill: "url(#ad)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.904061 21.7871c-.17653 0-.319588.1431-.319588.3196v1.4785c0 .0205.002117.0404.005823.0599.01153.0013.023235.002.035118.002h9.233996c.17649 0 .31959-.143.31959-.3196v-1.4784c0-.0206-.0021-.0405-.0058-.06-.0116-.0013-.0233-.002-.0351-.002z",
    fill: "url(#ae)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.85925 21.5293h-9.233998c-.17647 0-.319588-.1431-.319588-.3196v-1.4785c0-.1765.143059-.3196.319588-.3196h9.233998c.17645 0 .31955.1431.31955.3196v1.4785c0 .1764-.1431.3196-.31955.3196z",
    fill: "url(#af)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.6872 21.5293h-6.88965c-.1533 0-.27753-.1243-.27753-.2776v-1.5626c0-.1532.12423-.2775.27753-.2775h6.88965c.15323 0 .27753.1243.27753.2775v1.5626c0 .1533-.12424.2776-.27753.2776z",
    fill: "url(#ag)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.4285 21.5293h-2.37248c-.09241 0-.16735-.075-.16735-.1674v-1.7829c0-.0924.07494-.1674.16735-.1674h2.37248c.09241 0 .16735.075.16735.1674v1.7829c0 .0924-.07494.1674-.16735.1674z",
    fill: "url(#ah)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.904061 19.6694c-.17653 0-.319588.1431-.319588.3196v1.4785c0 .0205.002117.0405.005823.0599.01153.0013.023235.002.035118.002h9.233996c.17649 0 .31959-.143.31959-.3196v-1.4784c0-.0206-.0021-.0405-.0058-.06-.0116-.0012-.0233-.002-.0351-.002z",
    fill: "url(#ai)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.85925 19.4116h-9.233998c-.17647 0-.319588-.1431-.319588-.3196v-1.4785c0-.1765.143059-.3196.319588-.3196h9.233998c.17645 0 .31955.1431.31955.3196v1.4785c0 .1765-.1431.3196-.31955.3196z",
    fill: "url(#aj)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.6872 19.4117h-6.88965c-.1533 0-.27753-.1243-.27753-.2776v-1.5626c0-.1533.12423-.2776.27753-.2776h6.88965c.15323 0 .27753.1243.27753.2776v1.5626c0 .1533-.12424.2776-.27753.2776z",
    fill: "url(#ak)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.4285 19.4116h-2.37248c-.09241 0-.16735-.0749-.16735-.1674v-1.7829c0-.0924.07494-.1674.16735-.1674h2.37248c.09241 0 .16735.075.16735.1674v1.7829c0 .0925-.07494.1674-.16735.1674z",
    fill: "url(#al)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.904061 17.5518c-.17653 0-.319588.143-.319588.3195v1.4785c0 .0205.002117.0405.005823.06.01153.0012.023235.002.035118.002h9.233996c.17649 0 .31959-.1431.31959-.3196v-1.4785c0-.0205-.0021-.0405-.0058-.0599-.0116-.0013-.0233-.002-.0351-.002z",
    fill: "url(#am)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.904061 28.1401c-.17653 0-.319588.1431-.319588.3196v1.4785c0 .0205.002117.0405.005823.0599.01153.0013.023235.002.035118.002h9.233996c.17649 0 .31959-.143.31959-.3196v-1.4784c0-.0206-.0021-.0406-.0058-.06-.0116-.0012-.0233-.002-.0351-.002z",
    fill: "url(#S)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.904061 26.0225c-.17653 0-.319588.143-.319588.3195v1.4785c0 .0205.002117.0405.005823.06.01153.0013.023235.002.035118.002h9.233996c.17649 0 .31959-.1431.31959-.3196v-1.4785c0-.0205-.0021-.0405-.0058-.0599-.0116-.0013-.0233-.002-.0351-.002z",
    fill: "url(#W)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.904061 23.9048c-.17653 0-.319588.143-.319588.3196v1.4784c0 .0206.002117.0406.005823.06.01153.0012.023235.002.035118.002h9.233996c.17649 0 .31959-.1431.31959-.3196v-1.4785c0-.0205-.0021-.0404-.0058-.0599-.0116-.0013-.0233-.002-.0351-.002z",
    fill: "url(#aa)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.904061 21.7871c-.17653 0-.319588.1431-.319588.3196v1.4785c0 .0205.002117.0404.005823.0599.01153.0013.023235.002.035118.002h9.233996c.17649 0 .31959-.143.31959-.3196v-1.4784c0-.0206-.0021-.0405-.0058-.06-.0116-.0013-.0233-.002-.0351-.002z",
    fill: "url(#ae)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.904061 19.6694c-.17653 0-.319588.1431-.319588.3196v1.4785c0 .0205.002117.0405.005823.0599.01153.0013.023235.002.035118.002h9.233996c.17649 0 .31959-.143.31959-.3196v-1.4784c0-.0206-.0021-.0405-.0058-.06-.0116-.0012-.0233-.002-.0351-.002z",
    fill: "url(#ai)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.904061 17.5518c-.17653 0-.319588.143-.319588.3195v1.4785c0 .0205.002117.0405.005823.06.01153.0012.023235.002.035118.002h9.233996c.17649 0 .31959-.1431.31959-.3196v-1.4785c0-.0205-.0021-.0405-.0058-.0599-.0116-.0013-.0233-.002-.0351-.002z",
    fill: "url(#am)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.1737 30h-9.234c-.1765 0-.3196-.1431-.3196-.3196v-1.4785c0-.1765.1431-.3196.3196-.3196h9.234c.1765 0 .3196.1431.3196.3196v1.4785c0 .1765-.1431.3196-.3196.3196z",
    fill: "url(#an)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.0016 30h-6.8896c-.1532 0-.2775-.1243-.2775-.2776v-1.5625c0-.1533.1242-.2776.2775-.2776h6.8896c.1533 0 .2776.1243.2776.2776v1.5625c0 .1533-.1243.2776-.2776.2776z",
    fill: "url(#ao)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.7429 30h-2.3724c-.0924 0-.1674-.075-.1674-.1674v-1.7829c0-.0924.075-.1674.1674-.1674h2.3724c.0925 0 .1674.075.1674.1674v1.7829c0 .0924-.0749.1674-.1674.1674z",
    fill: "url(#ap)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.2183 28.1401c-.1765 0-.3196.1431-.3196.3196v1.4785c0 .0205.0021.0405.0058.0599.0115.0013.0232.002.0351.002h9.234c.1765 0 .3196-.143.3196-.3196v-1.4784c0-.0206-.0021-.0406-.0058-.06-.0115-.0012-.0232-.002-.0351-.002z",
    fill: "url(#aq)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.1737 27.8823h-9.234c-.1765 0-.3196-.1431-.3196-.3196v-1.4785c0-.1765.1431-.3196.3196-.3196h9.234c.1765 0 .3196.1431.3196.3196v1.4785c0 .1765-.1431.3196-.3196.3196z",
    fill: "url(#ar)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.0016 27.8824h-6.8896c-.1532 0-.2775-.1243-.2775-.2776v-1.5626c0-.1533.1242-.2776.2775-.2776h6.8896c.1533 0 .2776.1243.2776.2776v1.5626c0 .1533-.1243.2776-.2776.2776z",
    fill: "url(#as)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.7429 27.8823h-2.3724c-.0924 0-.1674-.0749-.1674-.1674v-1.7829c0-.0924.075-.1674.1674-.1674h2.3724c.0925 0 .1674.075.1674.1674v1.7829c0 .0925-.0749.1674-.1674.1674z",
    fill: "url(#at)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.2183 26.0225c-.1765 0-.3196.143-.3196.3195v1.4785c0 .0205.0021.0405.0058.06.0115.0013.0232.002.0351.002h9.234c.1765 0 .3196-.1431.3196-.3196v-1.4785c0-.0205-.0021-.0405-.0058-.0599-.0115-.0013-.0232-.002-.0351-.002z",
    fill: "url(#au)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashier3D);
export default __webpack_public_path__ + "static/media/cashier_3d.26a88f48f969f90fdd632da6e144d93e.svg";
export { ForwardRef as ReactComponent };